import { Interpolation, Theme, css } from '@emotion/react'

export const form: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 24px;
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 14px;
  padding: 16px;
`

export const textArea: Interpolation<Theme> = css`
  line-height: 24px;
  resize: vertical;
`

export const buttons: Interpolation<Theme> = css`
  display: flex;
  gap: 10px;

  > button {
    flex: 1;
  }
`

export const trashIcon = css`
  width: 22px !important;
  height: 22px !important;

  path {
    stroke: currentColor;
  }
`
